import { FC, useMemo, useContext, PropsWithChildren } from 'react';
import useInstitutions from '@/hooks/data/useInstitutions';
import InstitutionContext, { IInstitutionContext } from '@/contexts/data/InstitutionContext';
import IsLoading from '@/components/layouts/IsLoading';
import { useMatch, useParams } from 'react-router-dom';
import InstitutionsContext from '@/contexts/data/InstitutionsContext';


export interface IInstitutionProviderProps {
}

export const InstitutionProvider: FC<PropsWithChildren<IInstitutionProviderProps>> = ({ children }) => {
    const institutions = useContext(InstitutionsContext);

    const institutionCode = useParams()?.institutionCode;

    const institution  = useMemo(() => {
        if (!institutionCode) {
            return {
                data: undefined,
                error: undefined,
                loading: false,
                validating: false,
                refresh: async () => {
                    return undefined;
                },
            } as IInstitutionContext;
        }

        return {
            data: institutions.data?.find(x => x.code === institutionCode),
            code: institutionCode,
            error: institutions.error,
            loading: institutions.loading,
            validating: institutions.validating,
            refresh: async () => {
                const newData = await institutions.refresh();

                return newData?.find(x => x.code === institutionCode);
            },
        } as IInstitutionContext
    }, [institutions, institutionCode]);

    return (

        <InstitutionContext.Provider value={institution}>
            <IsLoading name="institution" loading={institution.loading} validating={institution.validating}/>
            {children}
        </InstitutionContext.Provider>
    );
}

export default InstitutionProvider;
